const fetchLocation = (opts = {}) => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      resolve({ lng: coords.longitude, lat: coords.latitude })
    }, reject, opts)
  })
}

export default fetchLocation



// WEBPACK FOOTER //
// ./src/assets/js/map/fetchLocation.js